import { Tab, Tabs, Rating } from "@mui/material";
import { useEffect, useState } from "react";
import { Row, Col, Input } from "reactstrap";
import { Button } from "reactstrap/lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

export default function APLRatingModal({
  questionsToDelete,
  setQuestionsToDelete,
  setNewStudentQuestions,
  setNewSupervisorQuestions,
  newStudentQuestions,
  newSupervisorQuestions,
}) {
  const [level, setLevel] = useState(false);
  const [toggledQuestion, setToggledQuestion] = useState(-1);

  useEffect(() => {
    setLevel("student");
  }, []);

  if (!newStudentQuestions || !newSupervisorQuestions) {
    return null;
  }
  const renderQuestions = (questionGroup) => {
    switch (questionGroup) {
      case "student":
        return (
          <div>
            {newStudentQuestions.map((question, index) => {
              return (
                <Row
                  key={"studQ" + index}
                  className="my-2 ms-0"
                  style={{ borderLeft: "lightgrey solid 1px" }}
                >
                  <Col lg={10}>
                    {toggledQuestion === index ? (
                      <div>
                        <Input
                          onDoubleClick={(event) => {
                            if (event.target.type !== "text") {
                              setToggledQuestion(-1);
                            }
                          }}
                          onKeyDown={(event) => {
                            if (
                              event.key === "Enter" ||
                              event.key === "Escape"
                            ) {
                              setToggledQuestion(-1);
                              event.preventDefault();
                              event.stopPropagation();
                            }
                          }}
                          onChange={(e) => {
                            var tempQuestionArray = [...newStudentQuestions];
                            tempQuestionArray[index].question = e.target.value;
                            setNewStudentQuestions(tempQuestionArray);
                          }}
                          type="text"
                          value={question.question}
                        />
                        <br />
                      </div>
                    ) : (
                      <TextHover
                        style={{ margin: "0" }}
                        onDoubleClick={() => {
                          setToggledQuestion(index);
                        }}
                        title="Dubbelklicka för att ändra"
                      >
                        {question.question}
                      </TextHover>
                    )}
                    <Rating
                      name="simple-controlled"
                      value={question.responseRange}
                      max={5}
                      onChange={(event, newValue) => {
                        var ratingQuestions = [...newStudentQuestions];
                        ratingQuestions[index].responseRange = newValue;
                        setNewStudentQuestions(ratingQuestions);
                      }}
                    />
                  </Col>
                  <Col lg={2} style={{ alignItems: "center" }}>
                    <Button
                      color="danger"
                      outline
                      className="mt-1"
                      style={{
                        textAlign: "center",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        var ratingQuestions;
                        if (question.id) {
                          ratingQuestions = [...questionsToDelete];
                          ratingQuestions.push(question);
                          setQuestionsToDelete(ratingQuestions);
                        }
                        ratingQuestions = [...newStudentQuestions];
                        ratingQuestions.splice(index, 1);
                        setNewStudentQuestions(ratingQuestions);
                      }}
                    >
                      <FontAwesomeIcon
                        icon="trash-alt"
                        style={{ transform: "scale(1.5)" }}
                      />
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </div>
        );
      case "supervisor":
        return (
          <div>
            {newSupervisorQuestions.map((question, index) => {
              return (
                <Row
                  key={"supQ" + index}
                  className="my-2 ms-0"
                  style={{ borderLeft: "lightgrey solid 1px" }}
                >
                  <Col>
                    {toggledQuestion === index ? (
                      <div>
                        <Input
                          onDoubleClick={(event) => {
                            if (event.target.type !== "text") {
                              setToggledQuestion(-1);
                            }
                          }}
                          onKeyDown={(event) => {
                            if (
                              event.key === "Enter" ||
                              event.key === "Escape"
                            ) {
                              setToggledQuestion(-1);
                              event.preventDefault();
                              event.stopPropagation();
                            }
                          }}
                          onChange={(e) => {
                            var tempQuestionArray = [...newSupervisorQuestions];
                            tempQuestionArray[index].question = e.target.value;
                            setNewSupervisorQuestions(tempQuestionArray);
                          }}
                          type="text"
                          value={question.question}
                        />
                        <br />
                      </div>
                    ) : (
                      <TextHover
                        style={{ margin: "0" }}
                        onDoubleClick={() => {
                          setToggledQuestion(index);
                        }}
                        title="Dubbelklicka för att ändra"
                      >
                        {question.question}
                      </TextHover>
                    )}
                    <Rating
                      name="simple-controlled"
                      value={question.responseRange}
                      max={5}
                      onChange={(event, newValue) => {
                        var ratingQuestions = [...newSupervisorQuestions];
                        ratingQuestions[index].responseRange = newValue;
                        setNewSupervisorQuestions(ratingQuestions);
                      }}
                    />
                  </Col>
                  <Col lg={2} style={{ alignItems: "center" }}>
                    <Button
                      color="danger"
                      outline
                      className="mt-1"
                      style={{
                        textAlign: "center",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (question.id) {
                          var ratingQuestions;
                          ratingQuestions = [...questionsToDelete];
                          ratingQuestions.push(question);
                          setQuestionsToDelete(ratingQuestions);
                        }
                        ratingQuestions = [...newSupervisorQuestions];
                        ratingQuestions.splice(index, 1);
                        setNewSupervisorQuestions(ratingQuestions);
                      }}
                    >
                      <FontAwesomeIcon
                        icon="trash-alt"
                        style={{ transform: "scale(1.5)" }}
                      />
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </div>
        );
      default:
        return null;
    }
  };

  const handleChange = (event, newValue) => {
    setToggledQuestion(-1);
    setLevel(newValue);
  };

  return (
    <div
      onClick={(event) => {
        if (toggledQuestion !== -1 && event.target.type !== "text") {
          setToggledQuestion(-1);
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    >
      <Tabs value={level} onChange={handleChange}>
        <Tab label="Elev" value="student" />
        <Tab label="Handledare" value="supervisor" />
      </Tabs>
      {renderQuestions(level)}
      <Button
        className="mt-2"
        color="primary"
        outline
        onClick={() => {
          if (level === "student") {
            var newQuestion;
            let temp = [...newStudentQuestions];
            newQuestion = {
              question: "Skriv din fråga här",
              responseRange: 5,
            };
            temp.push(newQuestion);
            setNewStudentQuestions(temp);
          } else if (level === "supervisor") {
            let temp = [...newSupervisorQuestions];
            newQuestion = {
              question: "Skriv din fråga här",
              responseRange: 5,
            };
            temp.push(newQuestion);
            setNewSupervisorQuestions(temp);
          }
        }}
      >
        <FormattedMessage id="AddQuestion" />
      </Button>
    </div>
  );
}

var TextHover = styled.p`
  width: fit-content;
  padding: 0 1rem 0 0;
  &:hover {
    border: 1px solid lightgrey;
  }
`;
